import React, { useState, useEffect, useRef } from 'react';
import { ID, isNode, Node } from './GraphData'
import * as cst from './cst'

interface SearchPanelProps {
  nodes : Node[]
  selectNode : Function
  selectedFilterOption : string
  setFilteredNodes : Function
}

export const SearchPanel : React.FC<SearchPanelProps> = ({nodes, selectNode, selectedFilterOption, setFilteredNodes}) => {
  const [nodesForRender, setNodesForRender] = useState<Node[]>([])

  useEffect(() => {
    let forRender = nodes.filter(node => node.state != cst.STATE_DONE)
    if(selectedFilterOption && selectedFilterOption != "None"){
      forRender = forRender.filter(node => node.owner == selectedFilterOption)
    }
    setNodesForRender(forRender)
    setFilteredNodes(forRender)
  }, [nodes, selectedFilterOption])

  const getByIndex = (idx : number) : ID => {
    return nodesForRender[idx].id
  }

  return (
    <div className="panel">
      {nodesForRender
        .map((node,index) => {
        let title=""
        if(node.title.length > 33){
          title = node.title.slice(0,30) + "..."
        }
        else{
          title = node.title
        }
        return (
          <div className="search-item" key={node.id} onClick={_e => selectNode(node.id)}>
            <div className="search-item-colorbar" style={{backgroundColor:node.color}}>
              {index+1}
            </div>
            <div className="search-item-content">
              {title}
            </div>
          </div>
        )
      })}
    </div>
  )
}
